import { PayableFilter } from "../../types/PayableFilter.types";
import PayableApi from "../api/PayableTable.api";

const PayableTableService = {
  /**
   * 📊 Lista las cuentas por pagar con filtros y paginación
   * POST /api/payables/search?page=0&size=10&sort=dueDate,desc
   */
  getFiltered: async (
    filters: PayableFilter,
    page = 0,
    size = 10,
    sort = "dueDate,desc"
  ) => {
    const response = await PayableApi.addCustom(
      `/search?page=${page}&size=${size}&sort=${sort}`,
      filters
    );

    return response.data;
  },

  /**
   * 💰 Obtener resumen para registrar pago
   * GET /api/payables/{id}/payment-summary
   */
  getPaymentSummary: async (id: number) => {
    const response = await PayableApi.fetchCustom(
      `/${id}/payment-summary`
    );

    return response.data;
  },

  /**
   * 🔥 Obtener cuentas pendientes por Proveedor
   * GET /api/payables/supplier/{supplierId}/pending?search=
   */
  getPendingBySupplier: async (
    supplierId: number,
    search?: string
  ) => {
    const query = search?.trim()
      ? `?search=${encodeURIComponent(search)}`
      : "";

    const response = await PayableApi.fetchCustom(
      `/supplier/${supplierId}/pending${query}`
    );

    return response.data;
  },

  /**
 * 🔥 Obtener cuentas para historial de pagos por Proveedor
 * GET /api/payables/supplier/{supplierId}/payment-history?search=
 */
  getPaymentHistoryBySupplier: async (
    supplierId: number,
    search?: string
  ) => {
    const query = search?.trim()
      ? `?search=${encodeURIComponent(search)}`
      : "";

    const response = await PayableApi.fetchCustom(
      `/supplier/${supplierId}/payment-history${query}`
    );

    return response.data;
  },
};

export default PayableTableService;